import React from 'react';
import { Form, Button, Header } from 'semantic-ui-react';

import PassengersInfo from './PassengersInfo';
import FlightsInfo from './FlightsInfo';

const CorrectClaimForm = ({
  loading,
  handleSubmit,
  onCancel,
  onPassengerChange,
  onRemovePassenger,
  onFlightChange,
  onFlightTimeChange,
  onRemoveFlight,
  ...restProps
}) => (
  <Form loading={loading}>
    <Header>Edit claim</Header>
    <PassengersInfo
      onPassengerChange={onPassengerChange}
      onRemovePassenger={onRemovePassenger}
      {...restProps}
    />
    <FlightsInfo
      onFlightChange={onFlightChange}
      onFlightTimeChange={onFlightTimeChange}
      onRemoveFlight={onRemoveFlight}
      {...restProps}
    />
    <Button primary onClick={handleSubmit} content="Save" />
    <Button basic onClick={onCancel} content="Cancel" />
  </Form>
);

export default CorrectClaimForm;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/Form/index.js